export default {"src":"/kelp/_next/static/media/tacEth.a18311f1.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};